<template>
  <section class="dp-layout tr-page stats-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="handleNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <header class="tr-hero">
        <div>
          <p class="tr-eyebrow">集体备课 · 数据分析</p>
          <h1 class="tr-title">备课统计</h1>
          <p class="tr-sub">查看教师上传、评价与二期流程参与情况，支持趋势对比。</p>
        </div>
        <div class="tr-hero__meta">
          <div class="tr-stat">
            <span>教师数</span>
            <strong>{{ total }}</strong>
          </div>
        </div>
      </header>

      <div class="tr-panel">
        <div class="tr-toolbar-wrap">
          <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
        </div>

                <!-- 列表：tbl-scroll-host + height 表体占满、空状态可见。最后更新：2026-08-31 -->
                <div class="tbl-scroll-host">
                <el-table height="100%" :data="tableData" v-loading="listLoading" class="tr-table v9-stats-table" style="width: 100%">
        <el-table-column label="教师基础信息" align="center">
          <el-table-column prop="TeacherName" label="教师姓名" width="" align="center">
            <template slot-scope="scope">
              <div class="user-cell">
                <div class="user-meta">
                  <div class="un">{{ scope.row.TeacherName }}</div>
                  <div class="gn">{{ scope.row.GroupName }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="UploadCount" label="上传文档" width="" align="center">
            <template slot-scope="scope">
              <span class="m-val highlight">{{ scope.row.UploadCount || 0 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="被评价指标 (来自他人)" align="center">
          <el-table-column prop="ViewCount" label="被查阅" width="" align="center"></el-table-column>
          <el-table-column label="评分 / 有效评语" width="150" align="center">
            <template slot-scope="scope">
              <div class="stat-cell">
                <span class="m-num">{{ scope.row.ReviewCount || 0 }}</span>
                <div class="s-tag" :title="'有效评语（字数阈值达标）：' + (scope.row.CommentCount || 0)">
                  <span>{{ scope.row.CommentCount || 0 }} 有效</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="AvgScore" label="评价均分" width="" align="center">
            <template slot-scope="scope">
              <span class="score-val" :class="getScoreClass(scope.row.AvgScore)">{{ scope.row.AvgScore.toFixed(1)
              }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="主动参与指标 (主动)" align="center" class-name="active-col-group" header-align="center">
          <el-table-column prop="ActiveViewCount" label="查阅他人" width="" align="center"></el-table-column>
          <el-table-column label="评分 / 有效评语" width="150" align="center">
            <template slot-scope="scope">
              <div class="stat-cell">
                <span class="m-num active">{{ scope.row.ActiveReviewCount || 0 }}</span>
                <div class="s-tag active" :title="'主动有效评语：' + (scope.row.ActiveCommentCount || 0)">
                  <span>{{ scope.row.ActiveCommentCount || 0 }} 有效</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ActiveAvgScore" label="评分均分" width="" align="center">
            <template slot-scope="scope">
              <span class="active-val" v-if="scope.row.ActiveReviewCount > 0">{{ scope.row.ActiveAvgScore.toFixed(1)
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="二期流程指标" align="center">
          <el-table-column prop="DiscussionParticipateCount" label="讨论参与" width="" align="center">
            <template slot-scope="scope">
              <span class="m-val">{{ scope.row.DiscussionParticipateCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="VoteParticipateCount" label="投票参与" width="" align="center">
            <template slot-scope="scope">
              <span class="m-val">{{ scope.row.VoteParticipateCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="LibraryDocCount" label="入库教案" width="" align="center">
            <template slot-scope="scope">
              <span class="m-val highlight">{{ scope.row.LibraryDocCount || 0 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleShowTrend(scope.row)">查看趋势</el-button>
          </template>
        </el-table-column>
      </el-table>
                </div>

        <div class="tr-pager">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="filters.Page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="filters.PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </section>

    <el-dialog :visible.sync="trendVisible" width="1000px" append-to-body custom-class="tr-dialog">
      <div slot="title" class="tr-dialog-title">
        <span class="tr-dialog-title__mark"></span>
        <div>
          <div class="tr-dialog-title__main">{{ trendTitle }}</div>
          <div class="tr-dialog-title__sub">被动评价 vs 主动参与趋势</div>
        </div>
      </div>
      <div class="trend-wrapper" v-loading="trendLoading">
        <div class="trend-grid" v-if="!trendLoading && trendData && trendData.length">
          <div class="trend-item">
            <div class="trend-header">
              <span class="th-dot passive"></span> 被评价指标 (来自他人)
            </div>
            <div ref="chartDomPassive" class="chart-container"></div>
          </div>
          <div class="trend-item">
            <div class="trend-header">
              <span class="th-dot active"></span> 主动参与指标 (主动)
            </div>
            <div ref="chartDomActive" class="chart-container"></div>
          </div>
        </div>
        <div v-if="!trendLoading && (!trendData || !trendData.length)" class="empty-placeholder">
          暂无趋势数据
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getTeacherStatistics, getAllGroups, getTeacherTrendStatistics, exportTeacherStatisticsExcel } from '../../api/modules/teaching-research';
import { getSubGrades } from '../../api/modules/department';
import { getButtonList } from "@/promissionRouter";
import Toolbar from "@/components/Toolbar";
import DepartmentPane from "@/components/DepartmentPane";
import * as echarts from 'echarts';
import util from "@/../util/date";
import { normalizeDeptId } from "@/utils/deptCascaderProps";

export default {
  name: "TeachingStatistics",
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      SchoolId: 0,
      listLoading: false,
      tableData: [],
      total: 0,
      buttonList: [],
      searchList: [
        { label: '教研组', key: 'GroupId', type: 'select', options: [], placeholder: '全部', initValue: null },
        { label: '教师姓名', key: 'TeacherName', type: 'input', placeholder: '姓名模糊搜索', initValue: '' },
        { label: '开始日期', key: 'From', type: 'date', initValue: null },
        { label: '结束日期', key: 'To', type: 'date', initValue: null }
      ],
      filters: {
        GroupId: null,
        TeacherName: '',
        From: null,
        To: null,
        Page: 1,
        PageSize: 10
      },
      // 趋势相关
      trendVisible: false,
      trendLoading: false,
      trendTitle: '教研趋势分析',
      trendData: [],
      chartPassive: null,
      chartActive: null
    };
  },
  methods: {
    getList() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "请先从左侧选择学校", type: "warning" });
        return;
      }
      this.listLoading = true;
      getTeacherStatistics({ ...this.filters, SchoolId: this.SchoolId })
        .then(res => {
          if (res.success) {
            const page = res.response || {};
            this.tableData = page.data || [];
            this.total = page.dataCount || 0;
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.error(res.msg || "获取统计失败");
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.filters.PageSize = val;
      this.filters.Page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.filters.Page = val;
      this.getList();
    },
    loadOptions(schoolId) {
      const para = { SchoolId: schoolId || 0 };
      getAllGroups(para).then(res => {
        if (res.success) {
          const groupSearch = this.searchList.find(i => i.key === "GroupId");
          if (groupSearch) {
            groupSearch.options = [{ label: "全部", value: null }, ...res.response.map(g => ({ label: g.GroupName, value: g.Id }))];
          }
        }
      });
    },
    // 工具栏回调
    callFunction(item) {
      if (item.Func === "handleQuery") {
        this.filters.Page = 1;
        this.filters = { ...this.filters, ...item.search };
        this.getList();
      } else if (item.Func === "exportExcel") {
        this.exportExcel();
      } else if (this[item.Func]) {
        this[item.Func].apply(this, [item]);
      }
    },
    async exportExcel() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "请先从左侧选择学校再进行导出", type: "error" });
        return;
      }
      try {
        let para = {
          SchoolId: this.SchoolId,
          ...this.filters
        };

        const response = await exportTeacherStatisticsExcel(para);
        if (!response.data) {
          this.$message.error("导出数据为空");
          return;
        }

        let fileName = "教师教研统计导出.xlsx";
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
            if (fileName.toLowerCase().startsWith("utf-8''")) {
              fileName = decodeURIComponent(fileName.substring(7));
            }
          }
        }

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功");
      } catch (error) {
        console.error('统计导出失败:', error);
        this.$message.error("导出失败");
      }
    },
    handleNodeClick(node) {
      if (!node || !node.value) return;
      this.SchoolId = node.value;
      this.filters.Page = 1;
      if (this.$refs.toolbar) {
        this.filters.GroupId = null;
        this.filters.From = null;
        this.filters.To = null;
        this.$refs.toolbar.searchObj = { GroupId: null, From: null, To: null };
      }
      this.loadOptions(this.SchoolId);
      this.getList();
    },
    getScoreClass(score) {
      if (score >= 4.5) return 'score-excellent';
      if (score >= 3.5) return 'score-good';
      return 'score-normal';
    },
    handleShowTrend(row) {
      this.trendTitle = `教研趋势分析 - ${row.TeacherName}`;
      this.trendVisible = true;
      this.trendLoading = true;

      const query = {
        TeacherUid: row.TeacherUid,
        GroupId: row.GroupId,
        From: this.filters.From,
        To: this.filters.To
      };

      getTeacherTrendStatistics(query).then(res => {
        if (res.success) {
          this.trendData = res.response;
        }
        this.trendLoading = false;
        this.$nextTick(() => {
          this.initChart();
        });
      });
    },
    initChart() {
      const domP = this.$refs.chartDomPassive;
      const domA = this.$refs.chartDomActive;
      if (!domP || !domA || !this.trendData.length) return;

      if (this.chartPassive) this.chartPassive.dispose();
      if (this.chartActive) this.chartActive.dispose();

      this.chartPassive = echarts.init(domP);
      this.chartActive = echarts.init(domA);

      const commonTooltip = {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 12,
        padding: 12,
        textStyle: { color: '#1e293b' },
        extraCssText: 'backdrop-filter: blur(4px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);'
      };

      const optionPassive = {
        backgroundColor: 'transparent',
        tooltip: commonTooltip,
        legend: {
          data: ['文档上传', '被查阅', '有效评语', '评价均分'],
          bottom: 0, itemGap: 12, icon: 'circle', textStyle: { color: '#64748b', fontSize: 11 }
        },
        grid: { top: '15%', left: '10%', right: '12%', bottom: '15%', containLabel: true },
        xAxis: {
          type: 'category', data: this.trendData.map(x => x.TimeLabel),
          axisLine: { lineStyle: { color: '#e2e8f0' } }, axisLabel: { color: '#94a3b8' }
        },
        yAxis: [
          { type: 'value', name: '次数', splitLine: { lineStyle: { type: 'dashed', color: '#f1f5f9' } }, axisLabel: { color: '#94a3b8' } },
          { type: 'value', name: '评分', max: 10, splitLine: { show: false }, axisLabel: { color: '#94a3b8' } }
        ],
        series: [
          { name: '文档上传', type: 'line', smooth: true, data: this.trendData.map(x => x.UploadCount), itemStyle: { color: '#1e3a8a' }, lineStyle: { width: 3 } },
          { name: '被查阅', type: 'line', smooth: true, data: this.trendData.map(x => x.ViewCount), itemStyle: { color: '#10b981' }, lineStyle: { width: 3 } },
          { name: '有效评语', type: 'line', smooth: true, data: this.trendData.map(x => x.CommentCount), itemStyle: { color: '#f59e0b' }, lineStyle: { width: 3 } },
          { name: '评价均分', type: 'line', yAxisIndex: 1, smooth: true, data: this.trendData.map(x => x.AvgScore.toFixed(1)), itemStyle: { color: '#ef4444' }, lineStyle: { width: 4, type: 'dashed' } }
        ]
      };

      const optionActive = {
        backgroundColor: 'transparent',
        tooltip: commonTooltip,
        legend: {
          data: ['查阅他人', '主动评价', '主动有效', '主动均分'],
          bottom: 0, itemGap: 12, icon: 'circle', textStyle: { color: '#64748b', fontSize: 11 }
        },
        grid: { top: '15%', left: '10%', right: '12%', bottom: '15%', containLabel: true },
        xAxis: {
          type: 'category', data: this.trendData.map(x => x.TimeLabel),
          axisLine: { lineStyle: { color: '#e2e8f0' } }, axisLabel: { color: '#94a3b8' }
        },
        yAxis: [
          { type: 'value', name: '次数', splitLine: { lineStyle: { type: 'dashed', color: '#f1f5f9' } }, axisLabel: { color: '#94a3b8' } },
          { type: 'value', name: '评分', max: 10, splitLine: { show: false }, axisLabel: { color: '#94a3b8' } }
        ],
        series: [
          { name: '查阅他人', type: 'line', smooth: true, data: this.trendData.map(x => x.ActiveViewCount), itemStyle: { color: '#3b82f6' }, lineStyle: { width: 3 } },
          { name: '主动评价', type: 'line', smooth: true, data: this.trendData.map(x => x.ActiveReviewCount), itemStyle: { color: '#3b82f6' }, lineStyle: { width: 3 } },
          { name: '主动有效', type: 'line', smooth: true, data: this.trendData.map(x => x.ActiveCommentCount), itemStyle: { color: '#ec4899' }, lineStyle: { width: 3 } },
          { name: '主动均分', type: 'line', yAxisIndex: 1, smooth: true, data: this.trendData.map(x => x.ActiveAvgScore.toFixed(1)), itemStyle: { color: '#fb923c' }, lineStyle: { width: 4, type: 'dashed' } }
        ]
      };

      this.chartPassive.setOption(optionPassive);
      this.chartActive.setOption(optionActive);
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 显式同步初始值到 toolbar 组件，避免日期初始化为今天的问题
    if (this.$refs.toolbar) {
      this.$refs.toolbar.searchObj = { ...this.$refs.toolbar.searchObj, ...this.filters };
    }
  }
};
</script>

<style scoped>
.stats-page .dp-right {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.v9-stats-table {
  border-radius: 10px;
  overflow: hidden;
}

/* 多级表头空数据时可能多出 gutter 占位，去掉右侧假边 */
.v9-stats-table /deep/ colgroup col[name="gutter"] {
  width: 0 !important;
}
.v9-stats-table /deep/ th.gutter,
.v9-stats-table /deep/ td.gutter {
  display: none !important;
  width: 0 !important;
  border: none !important;
}

.user-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.user-meta {
  text-align: center;
}

.user-meta .un {
  font-weight: 700;
  font-size: 14px;
  color: #0f172a;
}

.user-meta .gn {
  font-size: 11px;
  color: #94a3b8;
}

.score-val {
  font-weight: 800;
  font-size: 16px;
}

.score-excellent {
  color: #1e3a8a;
}

.score-good {
  color: #d97706;
}

.score-normal {
  color: #94a3b8;
}

.active-val {
  color: #3b82f6;
  font-weight: 700;
  font-size: 15px;
}

:deep(.active-col-group) {
  background-color: #eff6ff !important;
}

.m-val.highlight {
  color: #1e3a8a;
  font-weight: 700;
}

.stat-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
}

.m-num {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.m-num.active {
  color: #3b82f6;
}

.s-tag {
  margin-top: 4px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 10px;
  padding: 0 6px;
  border-radius: 10px;
  transform: scale(0.9);
  white-space: nowrap;
}

.s-tag.active {
  background: #e0f2fe;
  color: #3b82f6;
}

.trend-wrapper {
  padding: 8px 4px 12px;
}

.trend-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.trend-item {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.trend-header {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.th-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.th-dot.passive {
  background: #1e3a8a;
  box-shadow: 0 0 8px rgba(30, 58, 138, 0.35);
}

.th-dot.active {
  background: #3b82f6;
  box-shadow: 0 0 8px rgba(3, 105, 161, 0.35);
}

.chart-container {
  width: 100%;
  height: 360px;
}

.empty-placeholder {
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
}

@media (max-width: 960px) {
  .trend-grid {
    grid-template-columns: 1fr;
  }
}
</style>
